module.exports = __webpack_public_path__ + "img/master.46e2981e.svg";